import { Form } from "react-bootstrap";
import { FieldErrors, UseFormRegister } from "react-hook-form";

interface FormFields {
  comment: string;
  percentage: string;
}

interface BonusPercentageInputProps {
  country: "CO" | "MX";
  errors: FieldErrors<FormFields>;
  register: UseFormRegister<FormFields>;
}

export const BonusPercentageInput = ({
  country,
  register,
  errors,
}: BonusPercentageInputProps) => {
  const getValidationRules = () => {
    if (country === "CO") {
      return {
        max: {
          message: "El porcentaje no puede ser mayor a 3.5%",
          value: 3.5,
        },
        min: {
          message: "El porcentaje debe ser mayor o igual a 0",
          value: 0,
        },
        required: "Este campo es obligatorio",
      };
    }

    return {
      required: "Este campo es obligatorio", // MX aún requiere un valor
    };
  };

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between gap-2">
        <div className="percentage-label">% Bono:</div>
        <Form.Control
          className="percentage-input"
          type="number"
          placeholder="%"
          {...register("percentage", getValidationRules())}
          isInvalid={!!errors.percentage}
        />
      </div>
      {errors.percentage && (
        <Form.Control.Feedback type="invalid" className="d-block">
          {errors.percentage.message}
        </Form.Control.Feedback>
      )}
    </div>
  );
};
